import { UseQueryResult } from '@edreamsodigeo/frontend-api-client';
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useSearchRequestTimeMetric } from 'clientState/hooks/metrics';

type SearchTrackerContextType = {
  startSearch: () => void;
  endSearch: () => void;
};
const SearchTrackerContext = createContext<SearchTrackerContextType>({
  startSearch: /* istanbul ignore next */ () => {},
  endSearch: /* istanbul ignore next */ () => {},
});

const SearchTrackerProvider: React.FC<{
  endSearchMetric: () => void;
  initialState?: boolean;
}> = ({ children, endSearchMetric, initialState = false }) => {
  const [, setIsSearchRunning] = useState(initialState);

  const callbacks = useMemo(
    () => ({
      startSearch: () => setIsSearchRunning(true),
      endSearch: (): void => {
        setIsSearchRunning((currentIsSearchRunning) => {
          if (currentIsSearchRunning) {
            endSearchMetric?.();
          }
          return false;
        });
      },
    }),
    [endSearchMetric]
  );

  return (
    <SearchTrackerContext.Provider value={callbacks}>
      {children}
    </SearchTrackerContext.Provider>
  );
};

export const useSearchTracker = (): SearchTrackerContextType =>
  useContext(SearchTrackerContext);

export const useEndSearchMetricEffect = (
  query: UseQueryResult<unknown, object>
): void => {
  const { endSearch } = useSearchTracker();
  const { end: endSearchRequestMetric } = useSearchRequestTimeMetric();

  useEffect(() => {
    if (query.data && !query.loading && !query.errors) {
      endSearch();
      endSearchRequestMetric();
    }
  }, [
    query.loading,
    query.errors,
    query.data,
    endSearch,
    endSearchRequestMetric,
  ]);
};

export default SearchTrackerProvider;
